import SearchShop from './search-shop.vue'
export default SearchShop
